import { useTranslation } from "react-i18next";

import { useAlert } from "@/hooks/useAlert";
import { useLocalStorageFlag } from "@/hooks/useLocalStorageFlag";
import { useSimIdFromQueryParam } from "@/hooks/useSimIdFromQueryParam";
import { useGetRoaming } from "@/services/api";
import { RoamingInfoRoamingStatus } from "@/services/model";
import { AlertTypes } from "@/utils/atoms";

export const useRoamingInfoForDisplayedSim = () => {
  const [simId] = useSimIdFromQueryParam();
  const showAlert = useAlert();
  const { t } = useTranslation();
  const { shouldShowError, setErrorFired } = useLocalStorageFlag(
    "roamingErrorFiredAt",
  );
  const { data: roamingInfo } = useGetRoaming(
    {
      simIds: [Number(simId)],
    },
    {
      query: {
        enabled: !isNaN(parseInt(simId)),
        // update the roaming Info as long as it got "ordered" items
        refetchInterval: (data) => {
          if (
            data?.some(
              (roaming) =>
                roaming.roamingStatus === RoamingInfoRoamingStatus.ordered,
            )
          ) {
            return 2000;
          }

          return false;
        },
        onError: (err) => {
          if (shouldShowError()) {
            // Show error message
            showAlert({
              type: AlertTypes.info,
              text: t("Error.roamingError"),
            });
            setErrorFired();
          }
        },
      },
    },
  );

  return roamingInfo;
};
